import { useFormikContext } from 'formik';
import { Paper, Stack } from '@mui/material';
import { EmptyState, MediaContent, SortableList } from '@/components';
import MediaManager from '@/components/media-manager/MediaManager';
import { Content, Image } from '@/types';
import { useAccessControl } from '@/features/access-control';

interface SortableImage extends Image {
  id: string;
  label: string;
}

const Media = () => {
  const { hasAccess } = useAccessControl();
  const { values, setFieldValue } = useFormikContext<Pick<Content, 'images'>>();

  const onChange = (images: SortableImage[]) => {
    setFieldValue(
      'images',
      images.map(({ id }) => id)
    );
  };

  const onDelete = (images: SortableImage[]) => {
    setFieldValue(
      'images',
      images.map(({ id }) => id)
    );
  };

  const handleAddImage = (selection: string[]) => {
    const images = values?.images ?? [];
    setFieldValue('images', [...images, ...selection]);
  };

  if (!values?.images?.length) {
    return (
      <Paper
        elevation={2}
        sx={{
          padding: 2,
          borderRadius: 2,
        }}
      >
        <Stack spacing={2} padding={'32px 16px'}>
          <EmptyState />
          <MediaManager onChange={handleAddImage} multiple />
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 2,
        borderRadius: 2,
      }}
    >
      <Stack spacing={2}>
        <SortableList<unknown>
          items={(values?.images ?? []).map((url, index) => ({
            id: url,
            label: `Imagen ${index + 1}`,
          }))}
          onChange={onChange}
          onDelete={hasAccess('delete.media') ? onDelete : undefined}
          renderItem={(i) => {
            return <MediaContent src={i.id} />;
          }}
        />
        <MediaManager onChange={handleAddImage} multiple />
      </Stack>
    </Paper>
  );
};

export default Media;
